export const Apis = {
    loginApi: 'trillium-clinic-service/v1/authentication/clinic/user/login',
    ticketListApi: 'ticketing-tool/v1/ticket/list/all',
    providerList: 'dashboard-service-api/v1/provider/lists/all',
    loginInfoApi: 'trillium-internal-service/v1/common/cache',
    cacheListApi: 'trillium-internal-service/v1/common/list',
    typeList: 'trillium-internal-service/v1/issuetracker/type/list/',
    newTicket:'ticketing-tool/v1/ticket/'
}